import React from 'react'

const Doc = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/doc',
  ...props
}) => (
  <svg height='20' width='20' viewBox='0 0 20 20' style={style} {...props}>
    <g
      fill='none'
      fillRule='evenodd'
      transform='translate(1 1)'
    >
      <rect
        fill={primaryColor}
        height='90%'
        rx={2}
        width='90%'
      />
      <path
        d='M12.131 14h-1.774L9.171 7.586a7.88 7.88 0 0 1-.106-1.119h-.024c-.024.45-.07.823-.129 1.12L7.702 14H5.855L4 4h1.739l.998 6.658c.048.282.083.668.094 1.143h.035c.012-.347.059-.745.142-1.17L8.3 4h1.704l1.164 6.723c.047.243.082.603.117 1.067h.024c.011-.36.047-.732.094-1.119L12.39 4H14l-1.869 10z'
        fill={secondaryColor}
      />
    </g>
  </svg>
)

export default Doc
